'use client'

import { useMemo } from 'react'

import { Icon, IconComponent } from '@graftcode/design-system'
import * as Dialog from '@radix-ui/react-dialog'

import { getNavigationItems } from '../../../../config/navigation'
import { AppVariant } from '../../../../enums'

import styles from '../../MobileMenu.module.scss'

interface AppPickerDrawerProps {
  isOpen: boolean
  onClose: () => void
  currentApp: AppVariant
  onAppSelect: (appId: string, url: string) => void
}

export function AppPickerDrawer({ isOpen, onClose, currentApp, onAppSelect }: AppPickerDrawerProps) {
  const navigationItems = useMemo(() => getNavigationItems(currentApp), [currentApp])

  const handleAppClick = (appId: string, url: string, disabled?: boolean) => {
    if (disabled) return
    onAppSelect(appId, url)
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.appPickerOverlay} />
        <Dialog.Content className={styles.appPickerDrawer}>
          {/* Header */}
          <div className={styles.appPickerHeader}>
            <div className={styles.appPickerDragHandle} />
            <Dialog.Title className={styles.appPickerTitle}>Select app</Dialog.Title>
            <div className={styles.appPickerDivider} />
          </div>

          {/* App List */}
          <div className={styles.appPickerContent}>
            {navigationItems.map((item) => {
              const isSelected = item.id === currentApp
              const isDisabled = item.disabled

              return (
                <button
                  key={item.id}
                  className={`${styles.appPickerItem} ${isSelected ? styles.selected : ''} ${isDisabled ? styles.disabled : ''}`}
                  onClick={() => handleAppClick(item.id, item.url, isDisabled)}
                  disabled={isDisabled}
                >
                  <IconComponent icon={item.icon} size={20} className={styles.appPickerItemIcon} />
                  <span className={styles.appPickerItemLabel}>{item.label}</span>
                  {isSelected && (
                    <IconComponent icon={Icon.CheckmarkRegular} size={24} className={styles.appPickerCheckmark} />
                  )}
                </button>
              )
            })}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
